import { formatDateString } from "@utility/utilityFunctions";

export const splitSort = (str: string): [string, "asc" | "desc"] =>
  str.startsWith("-") ? [str.slice(1), "desc"] : [str, "asc"];

export const formatDateRange = (filters: Record<string, any>) => {
  if (!filters.fromDate || !filters.toDate) return null;
  return `${formatDateString(filters.fromDate)} - ${formatDateString(
    filters.toDate
  )}`;
};
